export var selectTooltipPayloadSearcher = state => state.options.tooltipPayloadSearcher;